
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class VoucherTaxDetailsDialog extends Serenity.EntityDialog<VoucherTaxDetailsRow, any> {
        protected getFormKey() { return VoucherTaxDetailsForm.formKey; }
        protected getIdProperty() { return VoucherTaxDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return VoucherTaxDetailsRow.localTextPrefix; }
        protected getService() { return VoucherTaxDetailsService.baseUrl; }
        protected getDeletePermission() { return VoucherTaxDetailsRow.deletePermission; }
        protected getInsertPermission() { return VoucherTaxDetailsRow.insertPermission; }
        protected getUpdatePermission() { return VoucherTaxDetailsRow.updatePermission; }

        protected form = new VoucherTaxDetailsForm(this.idPrefix);

    }
}